import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Button } from './TremorCompat';
import { Panel, Text } from 'rsuite';

export const DisplayPrimeButtonItem = ({
  register,
  tc,
  iconOn,
  iconOff,
  icon2On,
  icon2Off,
  onChange,
  disabled,
  altText,
  altText2,
  borderOff,
}) => {
  const [value, setValue] = useState(register.value);
  const [value2, setValue2] = useState(register.value);

  const updateValue = () => {
    let tempValue = value;

    if (register.value !== 1) {
      tempValue = 1;
    } else {
      tempValue = 0;
    }
    setValue(tempValue);
    onChange(register, tempValue);
  };

  const updateValue2 = () => {
    let tempValue = value2;
    if (register.value !== 2) {
      tempValue = 2;
    } else {
      tempValue = 0;
    }
    setValue2(tempValue);
    onChange(register, tempValue);
  };

  useEffect(() => {
    setValue(register.value);
    setValue2(register.value);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-2">
        <Button icon={register.value === 1 ? iconOn : iconOff} disabled={disabled} onClick={updateValue}>
          {' '}
          {altText === undefined ? register.display : altText}{' '}
        </Button>
        <Button icon={register.value === 2 ? icon2On : icon2Off} disabled={disabled} onClick={updateValue2}>
          {' '}
          {altText2 === undefined ? register.display : altText2}{' '}
        </Button>

        <div className="truncate">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>
      </Flex>
    </Panel>
  );
};
